import { render } from "./ClientsEmptyState.vue?vue&type=template&id=3dc6d513&scoped=true"
import script from "./ClientsEmptyState.vue?vue&type=script&lang=js"
export * from "./ClientsEmptyState.vue?vue&type=script&lang=js"

import "./ClientsEmptyState.vue?vue&type=style&index=0&id=3dc6d513&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc6d513"]])

export default __exports__